module.exports = __webpack_public_path__ + "static/img/empty_data.5858dd98.png";